import { Box, TColor } from '@bridebook/ui';
import { IconClass } from '@bridebook/web/lib/ui/constants';
import componentStyles from './featured-marker.style';

export interface IProps {
  color?: TColor;
}

const FeaturedMarker = ({ color = 'peachRose120' }: IProps) => {
  const styles = componentStyles({ color });

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.iconWrap}>
        <span className={IconClass.Hump} style={styles.humpIcon} />
        <span className={IconClass.FeaturedSupplier} style={styles.supplierIcon} />
      </Box>
      <Box style={styles.line} />
    </Box>
  );
};

export default FeaturedMarker;
